import {Component, Input, OnInit} from '@angular/core';
import {Breadcrumb, CmsComponent, CmsPage} from '@kion/data-models';
import {BreadcrumbFacade} from '../../../../../../shared/data-access/data-access-breadcrumb/src';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Component({
  selector: 'kion-cms-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

  @Input() component: CmsComponent;
  @Input() page: CmsPage;

  breadcrumbs$: Observable<Breadcrumb[]>;

  invertColor: boolean;

  constructor(private breadcrumbFacade: BreadcrumbFacade) {
  }

  ngOnInit(): void {
    this.invertColor = this.component.invertColor === "true";
    this.breadcrumbFacade.loadAll(this.page.uid, this.page.uid);
    this.breadcrumbs$ = this.breadcrumbFacade.breadcrumb$.pipe(
      map(
        (breadcrumbs: Breadcrumb[], index) => breadcrumbs.filter(
          (breadcrumb: Breadcrumb) => breadcrumb.page === this.page.uid /*&& breadcrumb.link.title !== 'Home'*/
        )
      )
    );
  }

}
